import styled, { css } from 'styled-components';
import { em } from 'polished';

import { greaterThan } from '../../utils/mediaQuery';
import theme from '../../styles/theme';

const Wrapper = css`
  max-width: ${(props) => (props.larger ? '1920px' : '1356px')};
  margin: 0 auto;
`;

export const Container = styled.div`
  ${Wrapper};

  box-sizing: content-box;

  padding-right: ${em(24)};
  padding-bottom: ${em(256)};
  padding-left: ${em(24)};

  ${greaterThan(theme.breakpoints.fonts[0])} {
    padding-right: ${em(56)};
    padding-left: ${em(56)};
  }
`;

export const Content = styled.div`
  /* padding-right: ${em(24)};
  padding-left: ${em(24)}; */

  /* ${greaterThan(1356)} {
    padding: 0;
  } */
`;
